import { buildOrderProductUniqueIdentifier } from '../../../../utils/getOrderProductUniqueIdentifier';
import {
  GetPendingOrderProductKeysParams,
  PendingOrderProductKeys,
} from '../interfaces/orderProducts.helper.interfaces';
import { OrderProductsSorter } from './sorter/OrderProductsSorterBuilder';

export const getPendingOrderProductKeys = ({
  orderProductsWithErrors,
  policyViolationsByItem,
}: GetPendingOrderProductKeysParams): PendingOrderProductKeys => {
  const keysWithErrors = Object.entries(orderProductsWithErrors)
    .filter(([, errors]) => errors.length > 0)
    .map(([key]) => key);

  return new Set([...keysWithErrors, ...policyViolationsByItem.keys()]);
};

export const hasOrderProductPendency = (
  { productColorId, availability, deliveryWindow }: OrderProductsSorter,
  pendingOrderProductKeys?: PendingOrderProductKeys,
) => {
  if (!productColorId || !availability) {
    return false;
  }

  return !!pendingOrderProductKeys?.has(
    buildOrderProductUniqueIdentifier({
      productColorId,
      availability,
      deliveryWindowId: deliveryWindow?.id ?? null,
    }),
  );
};
